import clsx from "clsx";
import React from "react";

type CheckboxProps = {
    label?: string | React.ReactNode;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
} & React.HTMLAttributes<HTMLInputElement>;

export default function Checkbox(props: CheckboxProps) {
    const { checked, onChange, onClick, label, className, ...rest } = props;
    return (
        <div className="flex items-center space-x-2">
            <div>
                <input
                    checked={checked}
                    id="green-checkbox"
                    type="checkbox"
                    onChange={onChange}
                    className={clsx("hidden", className)}
                    {...rest}
                />
                <i
                    onClick={onClick}
                    className={clsx(
                        "text-xl",
                        "cursor-pointer",
                        checked
                            ? "text-[#FFB903] ri-checkbox-fill"
                            : "text-slate-200 ri-checkbox-blank-line"
                    )}
                ></i>
            </div>

            {typeof label === "string" ? (
                <label htmlFor="green-checkbox" className="text-slate-600  text-[13px]">
                    {label}
                </label>
            ) : null}
            {typeof label === "object" ? label : null}
        </div>
    );
}
